export enum ConfidenceLevel {
  DEV = 'DEV',
  INTERNAL = 'INTERNAL',
  PROD = 'PROD',
}

export const confidencePrecedence = [ConfidenceLevel.DEV, ConfidenceLevel.INTERNAL, ConfidenceLevel.PROD];

export function checkConfidence(confidence: ConfidenceLevel) {
  const currentConfidence = process.env.REACT_APP_CONFIDENCE as ConfidenceLevel;

  const currentConfidenceIndex = confidencePrecedence.indexOf(currentConfidence);
  const minAllowedConfidenceIndex = confidencePrecedence.indexOf(confidence);
  const isWithinAllowedConfidences = currentConfidenceIndex <= minAllowedConfidenceIndex;

  return isWithinAllowedConfidences;
}
